import { Link, useNavigate, useParams } from "react-router-dom";
import APIs from "../../APIs";
import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setUserData } from "../../redux/authSlice";
import { setCategoryId } from "../../redux/shipmentSlice";
import { toast } from "react-toastify";
import { useGoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import jwt_decode from "jwt-decode";
import * as bootstrap from "bootstrap"; 
const Step1 = () => {
  const { categoryId: paramCategoryId } = useParams();

  const categoryId = useSelector((state) => state.shipment.categoryId);
  const userData = JSON.parse(sessionStorage.getItem("userData") || "{}");
    const userId = userData?.user_id;
    const [user, setUser] = useState({});
   const [forgotEmail, setForgotEmail] = useState("");
const [loadingForgot, setLoadingForgot] = useState(false);
const [resetPassword, setResetPassword] = useState({ password: "", confirmPassword: "" });
const [resetErrors, setResetErrors] = useState({});
const [loadingReset, setLoadingReset] = useState(false);
const [categoryName, setCategoryName] = useState("");
  const [categoryDescription, setCategoryDescription] = useState("");
  const [catName,setCatName] = useState('')
  const [catDest,setCatDest] = useState('')

const [showPassword, setShowPassword] = useState({
  password: false,
  confirmPassword: false,
});


const [countryList, setCountryList] = useState([])
const [loading4, setLoading4] = useState(false);
const [selectedCode, setSelectedCode] = useState([])

useEffect(() => {
  getCountryApi()
}, [])

useEffect(() => {
  if (countryList.length && !selectedCode) {
    setSelectedCode(countryList[0]);
  }
}, [countryList]);


const getCountryApi = async () => {
  setLoading4(true)
  try {
    const response = await APIs.post("user/getCountry", {});
    console.log("getCountryApi Response:", response.data.data[0]);

    if (response.data.status == "success") {
      setLoading4(false)
      setCountryList(response.data.data)
      setSelectedCode(response.data.data[0])
    } else {
      setLoading4(false)
      toast.error(response.data.message, { position: "top-right" });
    }
  } catch (error) {
    setLoading4(false)
    toast.error("Error getCountryApi", { position: "top-right" });
  } finally {
    setLoading4(false);
  }
};

 const handleForgotPasswordSubmit = async (e) => {
    e.preventDefault();
if (!forgotEmail) {
    toast.error("Please enter your email address", { position: "top-right"});
    return;
  }
    setLoadingForgot(true);
    setMessage("");

    try {
      const response = await APIs.post("user/forgotPassword", { email: forgotEmail }, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.data.status === "success") {
        const userData = response.data.data;
        dispatch(setUserData(userData));
        sessionStorage.setItem("userData", JSON.stringify(userData));
        setOtpSource("forgot"); // ✅ important for back button
        setTimeout(() => {
          const loginEl = document.getElementById("ForgotPasswordModalToggle");
          if (loginEl) {
            const loginModal =
              window.bootstrap.Modal.getInstance(loginEl) ||
              new window.bootstrap.Modal(loginEl);
            loginModal.hide();
          }

          const otpEl = document.getElementById("OtpModalToggle");
          if (otpEl) {
            const otpModal = new window.bootstrap.Modal(otpEl);
            otpModal.show();
          }
        }, 1000);
      } else {
        toast.error(response.data.message || "failed.", { position: "top-right"});
      }
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.message || "Failed. Please try again.",{ position: "top-right"});
    } finally {
      setLoadingForgot(false);
    }
  };
  const validateResetPassword = () => {
  const newErrors = {};
  if (!resetPassword.password) newErrors.password = "Password is required";
  else if (resetPassword.password.length < 6)
    newErrors.password = "Password must be at least 6 characters";

  if (!resetPassword.confirmPassword) newErrors.confirmPassword = "Confirm Password is required";
  else if (resetPassword.password !== resetPassword.confirmPassword)
    newErrors.confirmPassword = "Passwords do not match";

  setResetErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};

const handleResetPassword = async (e) => {
  e.preventDefault();
  setResetErrors(""); // optional top-level error

  if (!validateResetPassword()) return; // use per-field validation

  const storedUserData = JSON.parse(sessionStorage.getItem("userData"));
  const user_id = storedUserData?.user_id;
  if (!user_id) {
    setResetErrors("User not found.");
    return;
  }

  setLoadingReset(true);
  try {
    const response = await APIs.post("user/resetPassword", {
      user_id,
      password: resetPassword.password,
    });

    toast.success("Password reset successfully!", { position: "top-right" });

    const resetModalEl = document.getElementById("ResetPasswordModalToggle");
    const resetModal = window.bootstrap.Modal.getInstance(resetModalEl);
    resetModal.hide();

    const resetEl = document.getElementById("LoginModalToggle");
          if (resetEl) {
            const loginModal = new window.bootstrap.Modal(resetEl);
            loginModal.show();
          }
  } catch (error) {
    setResetErrors(error.response?.data?.message || "Failed to reset password");
  } finally {
    setLoadingReset(false);
  }
};


 
  
    useEffect(() => {
      const fetchUser = async () => {
        if (!userId) return;
        try {
          const res = await APIs.post(
            "user/getUserById",
            { user_id: userId },
            { headers: { "Content-Type": "application/json" } }
          );
          setUser(res.data?.data || {});
        } catch (err) {
          //console.error("Error fetching user:", err);
        }
      };
      fetchUser();
    }, [userId]);
  const [categories, setCategories] = useState([]);

  // Sync Redux categoryId with sessionStorage
  useEffect(() => {
    if (categoryId) 
      sessionStorage.setItem("categoryId", categoryId);
  }, [categoryId]);

  // Fetch categories
  useEffect(() => {
    getCategories();
    // Retrieve saved values from sessionStorage
    const savedCategoryName = sessionStorage.getItem("categoryName");
    const savedCategoryDescription = sessionStorage.getItem("categoryDescription");

    if (savedCategoryName) setCategoryName(savedCategoryName);
    if (savedCategoryDescription) setCategoryDescription(savedCategoryDescription);
    console.log("savedCategoryName", savedCategoryName);
    console.log("savedCategoryDescription", savedCategoryDescription);
  }, []);

  const getCategories = async () => {
    try {
      const response = await APIs.get("category/getAllCategory");
      if (response.data.status === "success") {
        const fetched = response.data.data;
        setCategories(fetched);

        const activeId = paramCategoryId || sessionStorage.getItem("categoryId");
        if (activeId) {
          const found = fetched.find(
            (cat) =>
              String(cat._id) === String(activeId) ||
              String(cat.category_id) === String(activeId)
          );
          if (found) dispatch(setCategoryId(found._id || found.category_id));
        }
      }
    } catch (error) {
      //console.error("Failed to fetch categories:", error);
      setCategories([]);
    }
  };
const handleContinue = () => {
  if (!categoryId) {
    toast.warning("Please select category.", { position: "top-right" });
    return;
  }
  navigate("/Step2");
};
    const [formData, setFormData] = useState({
      email: "",
      password: "",
      full_name: "",
      mobile_number: "",
      user_type: "",
    });
    const [errors, setErrors] = useState({});
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [toastData, setToastData] = useState(null);
    const [otpSource, setOtpSource] = useState(null);
    const [otp, setOtp] = useState(["", "", "", "", "", ""]); // 6-digit OTP
  
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const inputsRef = useRef([]);
  
    // ✅ Auto-clear messages after 5s
    useEffect(() => {
      if (message) {
        const timer = setTimeout(() => setMessage(""), 5000);
        return () => clearTimeout(timer);
      }
    }, [message]);
  
    // ✅ Load login email/password only
    useEffect(() => {
      const savedData = sessionStorage.getItem("loginFormData");
      if (savedData) {
        const parsed = JSON.parse(savedData);
        setFormData((prev) => ({
          ...prev,
          email: parsed.email || "",
          password: parsed.password || "",
        }));
      }
    }, []);
  
    // ✅ Save login email/password only
    useEffect(() => {
      sessionStorage.setItem(
        "loginFormData",
        JSON.stringify({ email: formData.email, password: formData.password })
      );
    }, [formData.email, formData.password]);
  
    // Handle input change
    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData((prev) => ({ ...prev, [name]: value }));
    };
  
    // Validate login form
    const validateLogin = () => {
      const newErrors = {};
      if (!formData.email) {
        newErrors.email = "Email is required";
      } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
        newErrors.email = "Enter a valid email";
      }
  
      if (!formData.password) {
        newErrors.password = "Password is required";
      } else if (formData.password.length < 6) {
        newErrors.password = "Password must be at least 6 characters";
      }
  
      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
    };
  
    // Validate signup form
    const validateSignup = () => {
      const newErrors = {};
      if (!formData.full_name) newErrors.full_name = "User Name is required";
      if (!formData.email) {
        newErrors.email = "Email is required";
      } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
        newErrors.email = "Enter a valid email";
      }
      if (!formData.mobile_number)
        newErrors.mobile_number = "Mobile number is required";
      if (!formData.user_type) newErrors.user_type = "User Type is required";
      if (!formData.password) {
        newErrors.password = "Password is required";
      } else if (formData.password.length < 6) {
        newErrors.password = "Password must be at least 6 characters";
      }
  
      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
    };
  
    // Login Submit
    const handleSubmit = async (e) => {
      e.preventDefault();
      if (!validateLogin()) return;
  
      setLoading(true);
      setMessage("");
  
      try {
        const response = await APIs.post("user/loginViaOTP", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
  
        if (response.data.status === "success") {
          const email = formData.email?.trim().toLowerCase();

          // ✅ Store only email temporarily until OTP verified
          sessionStorage.setItem("pendingUser", JSON.stringify({ email }));

          setToastData({
            title: "Login",
            message: response.data.message,
            type: "success",
            id: Date.now(),
          });
  
          setOtpSource("login"); // ✅ important for back button
          setTimeout(() => {
            const loginEl = document.getElementById("LoginModalToggle");
            if (loginEl) {
              const loginModal =
                window.bootstrap.Modal.getInstance(loginEl) ||
                new window.bootstrap.Modal(loginEl);
              loginModal.hide();
            }
  
            const otpEl = document.getElementById("OtpModalToggle");
            if (otpEl) {
              const otpModal = new window.bootstrap.Modal(otpEl);
              otpModal.show();
            }
          }, 1000);
        } else {
          toast.error(response.data.message || "Login failed.", { position: "top-right" });
        }
      } catch (error) {
        console.error(error);
        toast.error(error.response?.data?.message || "Login failed. Please try again.", { position: "top-right" });
      } finally {
        setLoading(false);
      }
    };
  
  const handleGoogleSuccess = async (tokenResponse) => {
    try {
      let email = "";
      let google_id = "";
  
      if (tokenResponse?.credential) {
        // From <GoogleLogin /> button
        const decoded = jwtDecode(tokenResponse.credential);
        email = decoded?.email || "";
        google_id = decoded?.sub || "";
      } else if (tokenResponse?.access_token) {
        // From useGoogleLogin() hook
        const userInfo = await fetch("https://www.googleapis.com/oauth2/v3/userinfo", {
          headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
        }).then((res) => res.json());
  
        email = userInfo?.email || "";
        google_id = userInfo?.sub || "";
      }
  
      if (!email || !google_id) {
        toast.error("Google login failed. Missing required info.", {
          position: "top-right",
        });
        return;
      }
  
      // ✅ Always use FormData for same API
      const formData = new FormData();
      formData.append("email", email.trim().toLowerCase());
      formData.append("google_id", google_id);
  
      const response = await APIs.post("user/loginViaOTP", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
  
      if (response.data.status === "success") {
        sessionStorage.setItem("pendingUser", JSON.stringify({ email }));
  
        setToastData({
          title: "Login",
          message: response.data.message,
          type: "success",
          id: Date.now(),
        });
  
        setOtpSource("login");
        setTimeout(() => {
          const loginEl = document.getElementById("LoginModalToggle");
          if (loginEl) {
            const loginModal =
              window.bootstrap.Modal.getInstance(loginEl) ||
              new window.bootstrap.Modal(loginEl);
            loginModal.hide();
          }
  
          const otpEl = document.getElementById("OtpModalToggle");
          if (otpEl) {
            const otpModal = new window.bootstrap.Modal(otpEl);
            otpModal.show();
          }
        }, 1000);
      } else {
        toast.error(response.data.message || "Login failed.", {
          position: "top-right",
        });
      }
    } catch (err) {
      console.error(err);
      toast.error("Google login error. Try again later.", {
        position: "top-right",
      });
    }
  };
  
  // Initialize the Google login hook
  const loginWithGoogle = useGoogleLogin({
    onSuccess: handleGoogleSuccess,
    onError: () => toast.error("Google Login Failed", { position: "top-right" }),
  });
  
    // Signup Submit
    const handleSignup = async (e) => {
      e.preventDefault();
      if (!validateSignup()) return;
  
      setMessage("");
  
      try {
        const payload = new FormData();
        payload.append("full_name", formData.full_name);
        payload.append("email", formData.email);
        payload.append("mobile_number", formData.mobile_number);
        payload.append("user_type", formData.user_type);
        payload.append("password", formData.password);
        payload.append("user_register_type", "Normal");
        payload.append("country_id", selectedCode.country_id);
        payload.append("country_code", selectedCode.country_code);
        console.log("user/createUser",payload)

        const response = await APIs.post("user/createUser", payload);
  
        const email = formData.email?.trim().toLowerCase();
        // ✅ Store only email temporarily
        sessionStorage.setItem("pendingUser", JSON.stringify({ email }));

        setToastData({
          title: "Signup",
          message: response.data.message,
          type: "success",
          id: Date.now(),
        });
  
        setOtpSource("signup"); // ✅ important for back button
        setTimeout(() => {
          const signupEl = document.getElementById("signupModalToggle");
          if (signupEl) {
            const signupModal =
              window.bootstrap.Modal.getInstance(signupEl) ||
              new window.bootstrap.Modal(signupEl);
            signupModal.hide();
          }
  
          const otpEl = document.getElementById("OtpModalToggle");
          if (otpEl) {
            const otpModal = new window.bootstrap.Modal(otpEl);
            otpModal.show();
          }
        }, 1000);
      } catch (error) {
        toast.error(error.response?.data?.message || "Signup failed. Try again.", { position: "top-right" });
      }
    };
  
    // OTP Handlers
    const handleChangeOTP = (e, idx) => {
      const val = e.target.value.replace(/[^0-9]/g, "");
      const newOtp = [...otp];
      newOtp[idx] = val ? val[0] : "";
      setOtp(newOtp);
      if (val && idx < 5) {
        inputsRef.current[idx + 1].focus();
      }
    };
  
    const handleBackspace = (e, idx) => {
      if (e.key === "Backspace" && !otp[idx] && idx > 0) {
        inputsRef.current[idx - 1].focus();
      }
    };
  
    const handleOTPSubmit = async (e) => {
      e.preventDefault();
      const otpValue = otp.join("");
      if (otpValue.length !== 6) {
        toast.warning("Enter 6-digit OTP", { position: "top-right" });
        return;
      }
  
      const pendingUser = JSON.parse(sessionStorage.getItem("pendingUser"));
      const email = pendingUser?.email;

      if (!email) {
        toast.warning("User email not found. Please login again.", { position: "top-right" });
        return;
      }
  
      setLoading(true);
      setMessage("");
      try {
        const response = await APIs.post("user/verifyOTP", { otp: otpValue, email });
        const verifiedUser = response.data.data;
        
              // ✅ Save verified user data
              dispatch(setUserData(verifiedUser));
              sessionStorage.setItem("userData", JSON.stringify(verifiedUser));
              sessionStorage.removeItem("pendingUser");
        
        toast.success("OTP verified successfully!", { position: "top-right" });
        console.log("OTP Response:", response.data);
  
        setTimeout(() => {
          //window.location.href = `/Step1/${categoryId}`; // ✅ full reload
          //navigate(`/Step1/${categoryId}`); 
          if (otpSource === "forgot") {
        const resetModalEl = document.getElementById("ResetPasswordModalToggle");
        const resetModal = new window.bootstrap.Modal(resetModalEl);
        resetModal.show();
      } else {
        window.location.href = `/Step1/${categoryId}`;
      }
        }, 1000);
      } catch (error) {
        toast.error(error.response?.data?.message || "OTP verification failed", { position: "top-right" });
      } finally {
        setLoading(false);
      }
    };
  
    const handleBack = () => {
      const otpModal = document.getElementById("OtpModalToggle");
      if (otpModal) {
        const modal = window.bootstrap.Modal.getInstance(otpModal);
        modal.hide();
      }
  
      if (otpSource === "login") {
        const loginModal = document.getElementById("LoginModalToggle");
        if (loginModal) {
          const modal = new window.bootstrap.Modal(loginModal);
          modal.show();
        }
      }
  
      if (otpSource === "signup") {
        const signupModal = document.getElementById("signupModalToggle");
        if (signupModal) {
          const modal = new window.bootstrap.Modal(signupModal);
          modal.show();
        }
      }
    };
  
    const handleResendOTP = async () => {
      try {
        const savedData = JSON.parse(sessionStorage.getItem("loginFormData"));
        const email = savedData?.email;
  
        if (!email) {
          toast.warning("Email not found. Please login again.", { position: "top-right" });
          return;
        }
  
        setLoading(true);
        setMessage("");
  
        const response = await APIs.post("user/resendOTP", { email });
  
        if (response.data.status === "success") {
          toast.success("OTP resent successfully!", { position: "top-right" });
        } else {
          toast.error(response.data.message || "Failed to resend OTP.", { position: "top-right" });
        }
      } catch (error) {
        console.error(error);
        toast.error(error.response?.data?.message || "Failed to resend OTP.", { position: "top-right" });
      } finally {
        setLoading(false);
      }
    };
    const handleCloseModal = (modalId) => {
  const modalEl = document.getElementById(modalId);
  const modalInstance =
    window.bootstrap.Modal.getInstance(modalEl) || 
    new window.bootstrap.Modal(modalEl);

  modalInstance.hide(); // properly hides the modal
  window.location.reload();
};

function initModalSwitcher() {
  const triggers = document.querySelectorAll('[data-bs-toggle="modal"][data-bs-dismiss="modal"]');

  triggers.forEach(trigger => {
    // Avoid duplicate listeners
    trigger.removeEventListener("click", handleModalSwitch);
    trigger.addEventListener("click", handleModalSwitch);
  });
}

/**
 * Handles switching between modals smoothly.
 */
function handleModalSwitch(e) {
  e.preventDefault();
  const trigger = e.currentTarget;
  const targetModalSelector = trigger.getAttribute("data-bs-target");
  const currentModal = trigger.closest(".modal");
  const targetModal = document.querySelector(targetModalSelector);

  if (currentModal && targetModal) {
    const currentModalInstance = bootstrap.Modal.getInstance(currentModal);
    currentModalInstance.hide();

    currentModal.addEventListener("hidden.bs.modal", function onHidden() {
      const newModal = new bootstrap.Modal(targetModal);
      newModal.show();
      currentModal.removeEventListener("hidden.bs.modal", onHidden);
    });
  }
}

// ✅ Initialize once when DOM is ready
document.addEventListener("DOMContentLoaded", initModalSwitcher);
useEffect(() => {
  initModalSwitcher();
}, []);

  return (
    <div className="page-wrapper about-us">
      {/* Main content */}
      <div className="page-content">
        <section className="step-section-md">
          <div className="container">
            <div className="row">
              {/* Left */}
              <div className="col-lg-6">
                <div className="shipment-information-new">                    
                  <div className="step-header">
                    <Link to="/">
                      <img src="/images/logo1.jpg" alt="Logo" className="img-fluid" />
                    </Link>
                    {user && Object.keys(user).length > 0 ? (
                      <div className="align-items-center d-flex gap-1">
                        <img
                          src={user.profile_image || "/images/user.png"}
                          alt="Profile"
                          style={{
                            width: "32px",
                            height: "32px",
                            borderRadius: "50%",
                            objectFit: "cover",
                            marginLeft: "25px",
                          }}
                        /><br></br>
                        <span>{user.full_name || ""}</span>
                      </div>
                    ) : (
                      <a  data-bs-toggle="modal" href="#LoginModalToggle">
                      <i class="eagle-base-icon-user"></i> Sign In</a>
                    )}
                  </div>
                  <div className="new-title">
                      <h3>{catName || "Important Documents"}</h3>
                      <p>
                        {catDest ||
                          "Rely on us for the swift and secure transport of sensitive, time-critical documents, ensuring confidentiality and timely arrival every time."}
                      </p>
                      <h6>Why Choose Us</h6>
                      <div className="about__list-box about__list-box-two">
                          <ul className="list-wrap">
                              <li><i className="flaticon-check"></i>Ultra-Fast Delivery: Next-flight-out (NFO) options worldwide.</li>
                              <li><i className="flaticon-check"></i>Freelance Couriers: Global network of experienced OBC professionals.</li>
                              <li><i className="flaticon-check"></i>Digital Convenience: Book, quote, and track—all online.</li>
                              <li><i className="flaticon-check"></i>Secure &amp; Reliable: Each shipment is escorted personally.</li>
                          </ul>
                      </div>
                  </div>
                  <img src="/images/banner-slider-img/3.png" className="img-fluid" alt="Banner" />
                </div>
              </div>

              {/* Right */}
              <div className="col-lg-6">
                <div className="shipment-details-new">
                  <h3 className="step-count">STEP 1/5</h3>
                  <h3 className="new-title">Select Category</h3>
                  <div className="col-12 new-location-wraper">
                    <div className="raio-image-wrapper">
                      {categories.map((cat) => {
                        const id = cat._id || cat.category_id;
                        return (
                          <div className="image-radio" key={id}>
                            <input
                              className="form-check-input"
                              type="radio"
                              name="category"
                              id={`category-${id}`}
                              checked={String(categoryId) === String(id)}
                              // onChange={() => dispatch(setCategoryId(id))}
                              onChange={() => {
                                dispatch(setCategoryId(id));

                                // Store category info in sessionStorage
                                sessionStorage.setItem("categoryId", id);
                                sessionStorage.setItem("categoryName", cat.category_name || "");
                                sessionStorage.setItem("categoryDescription", cat.category_description || "");
                                setCatName(cat.category_name)
                                setCatDest(cat.category_description)
                              }}
                            />
                            <label className="form-check-label" htmlFor={`category-${id}`}>
                              <img src={cat.category_image || "/images/homepage-2/ihbox/icon-img-01.png"} alt={cat.category_name} />
                              <h5>{cat.category_name}</h5>
                            </label>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <button onClick={handleContinue} className="btn btn-success btn-lg w-100">Continue</button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* Modals */}
 {/* Signup Modal */}
      <div
        className="modal fade commen-popup"
        id="signupModalToggle"
        aria-hidden="true"
        aria-labelledby="signupModalToggleLabel2"
        tabIndex="-1"
        data-bs-backdrop="static"
        data-bs-keyboard="false" 
      >
        <div className="modal-dialog modal-xl modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body" style={{ display: 'list-item' }}>
              <div className="row">
                <div className="col-lg-6">
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={() => handleCloseModal("signupModalToggle")}
                  ></button>
                  <div className="col-md-12 text-center">
                        {message && (
                          <div
                            className={`alert ${
                              message.toLowerCase().includes("success")
                                ? "alert-success bg-success text-white"
                                : "alert-danger bg-danger text-white"
                            }`}
                            role="alert"
                          >
                            {message}
                          </div>
                        )}
                      </div>
                  <h5 className="modal-title">Sign Up</h5>
                  <p>
                    Welcome Back! Let&apos;s get started. Please sign in to access all the amazing services
                  </p>

                  {/* Signup Form */}
                  <form className="signup-form" onSubmit={handleSignup}>
                    <div className="row">
                      <div className="col-sm-12 mb-2">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="User Name *"
                          name="full_name"
                          value={formData.full_name}
                          onChange={handleChange}
                        />
                        {errors.full_name && <small className="text-danger">{errors.full_name}</small>}
                      </div>

                      <div className="col-sm-12  mb-2">
                        <input
                          type="email"
                          className="form-control"
                          placeholder="Your Email *"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                        />
                        {errors.email && <small className="text-danger">{errors.email}</small>}
                      </div>

                      <div className="col-sm-12 mb-6">
                        <div className="input-group d-flex gap-2">
                          <div className="flex-shrink-0">
                            {/* Country Code Dropdown */}
                            <select
                              value={selectedCode ? String(selectedCode.country_id) : ""}
                              onChange={(e) => {
                                const selectedId = Number(e.target.value);

                                const country = countryList.find(
                                  (c) => c.country_id === selectedId
                                );

                                setSelectedCode(country);
                                console.log("Selected country:", country);
                              }}
                              style={{
                                color: "black",
                                background: "white",
                                border: "1px solid #ced4da",    // small gray border
                                borderRadius: "4px",         // optional: slightly rounded corners
                                outline: "none",             // removes focus outline
                                boxShadow: "none",           // remove any shadow
                                padding: "2px 4px 0px 10px",          // compact padding
                                fontSize: "0.85rem",         // slightly smaller text
                                appearance: "none",          // remove default arrow styling in some browsers
                                WebkitAppearance: "none",
                                MozAppearance: "none",
                                marginRight: "10px",
                              }}
                            >
                              {/* placeholder */}
                              <option value="" hidden>
                                Code
                              </option>

                              {countryList.map((c) => (
                                <option key={c.country_id} value={String(c.country_id)}>
                                  {c.country_name} {c.country_code}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div className="flex-grow-1">
                            {/* Mobile Number */}
                            <input
                              type="tel"
                              className="form-control"
                              placeholder="Your mobile number *"
                              name="mobile_number"
                              value={formData.mobile_number}
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                        {errors.mobile_number && (
                          <small className="text-danger">{errors.mobile_number}</small>
                        )}
                      </div>

                      <div className="col-sm-12 mb-2">
                        <select
                          className="form-control select-control"
                          name="user_type"
                          value={formData.user_type}
                          onChange={handleChange}
                        >
                          <option value="">User Type</option>
                          <option value="Individual">Individual Customer</option>
                          <option value="Corporate">Corporate</option>
                        </select>
                        {errors.user_type && <small className="text-danger">{errors.user_type}</small>}
                      </div>

                      <div className="col-sm-12 mb-2">
                        <input
                          type={showPassword.password ? "text" : "password"}
                          className="form-control"
                          placeholder="Your Password *"
                          name="password"
                          value={formData.password}
                          onChange={handleChange}
                        />
                        <span
                            className="position-absolute"
                            style={{
                              cursor: "pointer",
                              top: "74%",
                              right: "595px",
                              transform: "translateY(-50%)",
                            }}
                            onClick={() =>
                              setShowPassword({
                                ...showPassword,
                                password: !showPassword.password,
                              })
                            }
                          >
                            <i
                              className={`${
                                showPassword.password ? "bi bi-eye-slash" : "bi bi-eye"
                              }`}
                            ></i>
                          </span>
                        {errors.password && <small className="text-danger">{errors.password}</small>}
                      </div>

                      <div className="col-md-12 mb-3">
                        <button type="submit" className="eagle-btn w-100 text-center">
                          <span className="eagle-button-text">Signup</span>
                          <span className="eagle-button-icon-wrapper">
                            <span className="eagle-button-icon">
                              <i className="eagle-base-icon-black-arrow-1"></i>
                            </span>
                          </span>
                        </button>
                      </div>

                      

                      <div className="col-md-12 col-lg-12">
                        Already have an account?{" "}
                        <a
  data-bs-target="#LoginModalToggle"
  data-bs-toggle="modal"
  data-bs-dismiss="modal"
                        >
                          Login Now!
                        </a>
                      </div>
                    </div>
                  </form>
                </div>

                <div className="col-lg-6">
                  <img src="/images/banner-slider-img/1.jpg" className="img-fluid" alt="Signup" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    { /* End */}
    {/* Model  */}
          {/* Login Modal */}
            <div
            className="modal fade commen-popup"
            id="LoginModalToggle"
            aria-hidden="true"
            aria-labelledby="LoginModalToggleLabel"
            tabIndex="-1"
            data-bs-backdrop="static"
        data-bs-keyboard="false" 
          >
            <div className="modal-dialog modal-lg modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body" style={{ display: 'list-item' }}>
                  <div className="row">
                    <div className="col-lg-6">
                      <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={() => handleCloseModal("LoginModalToggle")}
                  ></button>
                    {message && (
                          <div
                            className={`alert ${
                              message.toLowerCase().includes("success")
                                ? "alert-success bg-success text-white"
                                : "alert-danger bg-danger text-white"
                            }`}
                            role="alert"
                          >
                            {message}
                          </div>
                        )}
                      <h5 className="modal-title" id="LoginModalToggleLabel">
                        Login
                      </h5>
                      <p>
                        Welcome Back! Let's get started. Please sign in to access all
                        the amazing services
                      </p>

                      <form
                        className="Login-form"
                        onSubmit={handleSubmit}
                        noValidate
                      >
                        <div className="row">
                          <div className="col-sm-12 mb-2">
                            <input
                              type="email"
                              className="form-control"
                              placeholder="Email *"
                              name="email"
                              value={formData.email}
                              onChange={handleChange}
                            />
                            {errors.email && (
                              <small className="text-danger">{errors.email}</small>
                            )}
                          </div>

                          <div className="col-sm-12 mb-2">
                            <input
                              type={showPassword.password ? "text" : "password"}
                              className="form-control"
                              placeholder="Password *"
                              name="password"
                              value={formData.password}
                              onChange={handleChange}
                            />
                            <span
                              className="position-absolute"
                              style={{
                                cursor: "pointer",
                                top: "44%",
                                right: "426px",
                              }}
                              onClick={() =>
                                setShowPassword({
                                  ...showPassword,
                                  password: !showPassword.password,
                                })
                              }
                            >
                             <i
                              className={`bi ${
                                showPassword.password ? "bi-eye-slash-fill" : "bi-eye-fill"
                              }`}
                              style={{ fontSize: "1.2rem", color: "#555" }}
                            ></i>
                            </span>
                            {errors.password && (
                              <small className="text-danger">{errors.password}</small>
                            )}
                            <a
                              href="#"
                              data-bs-target="#ForgotPasswordModalToggle"
                              data-bs-toggle="modal"
                              className="float-end mt-1"
                            >
                              <small>Forgot Password?</small>
                            </a>
                          </div>

                          <div className="col-md-12 mb-3">
                            <button
                              type="submit"
                              className="eagle-btn text-center w-100"
                              disabled={loading}
                            >
                              <span className="eagle-button-text">
                                {loading ? "Logging in..." : "Login"}
                              </span>
                              <span className="eagle-button-icon-wrapper">
                                <span className="eagle-button-icon">
                                  <i className="eagle-base-icon-black-arrow-1"></i>
                                </span>
                              </span>
                            </button>
                          </div>

                          <div className="col-md-12 mb-3">
                            <button
                              type="button"
                              className="loginwith-google text-center eagle-btn w-100"
                              onClick={() => loginWithGoogle()}
                            >
                              <img
                                src="/images/google.svg"
                                className="img-fluid"
                                alt="google"
                              />
                              <span className="eagle-button-text">Login with Google</span>
                            </button>
                          </div>

                          <div className="col-md-12 col-lg-12">
                            Don't have an account?{" "}
                            <a
                              href="javascript:void(0)"
                              data-bs-target="#signupModalToggle"
                              data-bs-toggle="modal"
                              data-bs-dismiss="modal"
                            >
                              Sign Up Now!
                            </a>
                          </div>

                        
                        </div>
                      </form>
                    </div>

                    <div className="col-lg-6">
                      <img
                        src="/images/banner-slider-img/1.jpg"
                        className="img-fluid"
                        alt="banner"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div>
     
          {/* End Login Model  */}
          <div
            className="modal fade commen-popup"
            id="OtpModalToggle"
            aria-hidden="true"
            aria-labelledby="OtpModalToggleLabel"
            tabIndex="-1"
            data-bs-backdrop="static"
            data-bs-keyboard="false" 
            >
            <div className="modal-dialog modal-lg modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body" style={{ display: 'list-item' }}>
                  <div className="row">
                    <div className="col-lg-6">
                      <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={() => handleCloseModal("OtpModalToggle")}
                  ></button>
                      {message && (
                          <div
                            className={`alert ${
                              message.toLowerCase().includes("success")
                                ? "alert-success bg-success text-white"
                                : "alert-danger bg-danger text-white"
                            }`}
                            role="alert"
                          >
                            {message}
                          </div>
                        )}
                      <h5 className="mt-2">Enter OTP</h5>
                      <p>Please check your emails, including the spam folder, for the one time password we sent you.</p>

                      <form onSubmit={handleOTPSubmit}>
                        <div className="d-flex gap-2 mb-3">
                          {otp.map((digit, idx) => (
                            <input
                              key={idx}
                              type="text"
                              className="form-control text-center"
                              maxLength={1}
                              value={digit}
                              onChange={(e) => handleChangeOTP(e, idx)}
                              onKeyDown={(e) => handleBackspace(e, idx)}
                              ref={(el) => (inputsRef.current[idx] = el)}
                            />
                          ))}
                        </div>

                        <div className="col-md-12 gap-2 mb-3 d-flex">
                          <button
                            type="button"
                            className="eagle-btn text-center w-50"
                            onClick={handleBack}
                          >
                            BACK
                          </button>
                          <button
                            type="submit"
                            className="eagle-btn text-center w-50"
                            disabled={loading}
                          >
                            {loading ? "Verifying..." : "VERIFY"}
                          </button>
                        </div>
                        <div className="mb-2">
                          Didn't receive an OTP?{" "}
                          <button
                              type="button"
                              className="btn btn-link p-0"
                              onClick={handleResendOTP}
                              disabled={loading}
                          >
                              {loading ? "Resending..." : "Resend"}
                          </button>
                          </div>

                      </form>
                    </div>

                    <div className="col-lg-6">
                      <img
                        src="/images/banner-slider-img/1.jpg"
                        className="img-fluid"
                        alt="banner"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
           {/* Forgot Password Modal */}
          <div
            className="modal fade commen-popup"
            id="ForgotPasswordModalToggle"
            aria-hidden="true"
            aria-labelledby="ForgotPasswordModalToggleLabel"
            tabIndex="-1"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
          >
            <div className="modal-dialog modal-lg modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body" style={{ display: "list-item" }}>
                  <div className="row">
                    <div className="col-lg-6">
                      <button
                        type="button"
                        className="btn-close"
                        aria-label="Close"
                        onClick={() => handleCloseModal("ForgotPasswordModalToggle")}
                      ></button>

                      <h5 className="modal-title" id="ForgotPasswordModalToggleLabel">
                        Forgot Password
                      </h5>
                      <p>
                        Enter your email id and we'll send you instructions to reset your password
                      </p>

                      <form
                        className="Login-form"
                        onSubmit={handleForgotPasswordSubmit}
                        noValidate
                      >
                        <div className="row">
                          <div className="col-sm-12 mb-2">
                            <input
                              type="email"
                              className="form-control"
                              placeholder="Email *"
                              name="forgotEmail"
                              value={forgotEmail}
                              onChange={(e) => setForgotEmail(e.target.value)}
                            />
                          </div>

                          <div className="col-md-12 mb-3 d-flex justify-content-between">
                            <button
                              type="button"
                              className="eagle-btn text-center w-50 me-2"
                              data-bs-target="#LoginModalToggle"
                              data-bs-toggle="modal"
                              data-bs-dismiss="modal"
                            >
                              BACK
                            </button>
                            <button
                              type="submit"
                              className="eagle-btn text-center w-50"
                              disabled={loadingForgot}
                            >
                              <span className="eagle-button-text">
                                {loadingForgot ? "Sending..." : "Send OTP"}
                              </span>
                              <span className="eagle-button-icon-wrapper">
                                <span className="eagle-button-icon">
                                  <i className="eagle-base-icon-black-arrow-1"></i>
                                </span>
                              </span>
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>

                    <div className="col-lg-6">
                      <img
                        src="images/banner-slider-img/1.jpg"
                        className="img-fluid"
                        alt="Forgot Password"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* RESET PASSWORD MODAL */}
                <div
            className="modal fade commen-popup"
            id="ResetPasswordModalToggle"
            tabIndex="-1"
            aria-hidden="true"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
          >
            <div className="modal-dialog modal-lg modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body">
                  <div className="row">
                    <div className="col-lg-6">
                      <button
                        type="button"
                        className="btn-close"
                        aria-label="Close"
                        onClick={() => handleCloseModal("ResetPasswordModalToggle")}
                      ></button>

                      <h5 className="modal-title">Reset Password</h5>
                      <p>Enter your new password below</p>

                      <form onSubmit={handleResetPassword}>
                        <div className="mb-2 position-relative">
                          <input
                            type={showPassword.password ? "text" : "password"}
                            className="form-control"
                            placeholder="New Password"
                            value={resetPassword.password}
                            onChange={(e) =>
                              setResetPassword({ ...resetPassword, password: e.target.value })
                            }
                          />
                          <span
                            className="position-absolute"
                            style={{
                              cursor: "pointer",
                              top: "50%",
                              right: "15px",
                              transform: "translateY(-50%)",
                            }}
                            onClick={() =>
                              setShowPassword({
                                ...showPassword,
                                password: !showPassword.password,
                              })
                            }
                          >
                            <i
                              className={`${
                                showPassword.password ? "bi bi-eye-slash" : "bi bi-eye"
                              }`}
                            ></i>
                          </span>
                          {resetErrors.password && (
                            <small className="text-danger">{resetErrors.password}</small>
                          )}
                        </div>

                        <div className="mb-2 position-relative">
                          <input
                            type={showPassword.confirmPassword ? "text" : "password"}
                            className="form-control"
                            placeholder="Confirm Password"
                            value={resetPassword.confirmPassword}
                            onChange={(e) =>
                              setResetPassword({
                                ...resetPassword,
                                confirmPassword: e.target.value,
                              })
                            }
                          />
                          <span
                            className="position-absolute"
                            style={{
                              cursor: "pointer",
                              top: "50%",
                              right: "15px",
                              transform: "translateY(-50%)",
                            }}
                            onClick={() =>
                              setShowPassword({
                                ...showPassword,
                                confirmPassword: !showPassword.confirmPassword,
                              })
                            }
                          >
                            <i
                              className={`${
                                showPassword.confirmPassword ? "bi bi-eye-slash" : "bi bi-eye"
                              }`}
                            ></i>
                          </span>
                          {resetErrors.confirmPassword && (
                            <small className="text-danger">{resetErrors.confirmPassword}</small>
                          )}
                        </div>

                        <button type="submit" className="eagle-btn w-100" disabled={loadingReset}>
                          {loadingReset ? "Resetting..." : "Reset Password"}
                        </button>
                      </form>

                    </div>

                    <div className="col-lg-6">
                      <img
                        src="/images/banner-slider-img/1.jpg"
                        className="img-fluid"
                        alt="Reset Password"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

    </div>
  );
};

export default Step1;
